import { TOGGLE_LOADING } from "redux/TypeConstant"

const LoadingReducer=(state=false,action)=>{
    switch(action.type)
    {
        case TOGGLE_LOADING:
        return !state

        default:
            return state
    }

}

export default LoadingReducer